import { Atom, wrap, Wrapper } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.iframe`
  ${({ displayState }) => css`
    width: 100%;
    height: ${displayState?.height ?? '200vh;'};
    object-fit: contain;
  `}
`;

const wrapper = styled.div`
  flex-grow: 1;
  position: relative;
  width: 100%;
`;

let atom = Atom({ type: 'video', dataType: 'string', template })

export default wrap(atom, Wrapper(wrapper))
